// Site-wide date formatting: "D Month YYYY" (e.g. "9 July 2026").
export function fmtLongDate(value) {
    if (!value) return "";
    const d = new Date(value);
    if (Number.isNaN(d.getTime())) return String(value);
    return d.toLocaleDateString("en-GB", {
        day: "numeric",
        month: "long",
        year: "numeric",
    });
}

// Categories that hide the read-time in the Studio Life metadata line.
const NO_READ_TIME = new Set(["STUDIO LIFE", "PRESS & AWARDS"]);

export function showsReadTime(category) {
    return !NO_READ_TIME.has((category || "").toUpperCase());
}
